import sdkFactory from '@yandex-data-ui/sdk';
import type {GatewayError} from '@yandex-data-ui/sdk/build/models/common';
import get from 'lodash/get';

import type {AxiosResponse} from 'axios';

import {i18n} from '~ui/components/WikiPage/i18n';

import toaster from '~ui/utils/toaster';

import {Header} from '../../shared/constants';
import type {Schema} from '../../shared/schema';

const sdk = sdkFactory<{root: typeof Schema}>({
    csrfToken: get(window.__DATA__, 'secretkey', ''),
    endpoint: '/.gateway',
    handleRequestError: (errorResponse: unknown) => {
        const error = errorResponse as AxiosResponse;
        let parsedError = {} as GatewayError;
        const errorData = get(error, 'data');

        if (errorData) {
            if (errorData.code === 'SERVICE_IS_READONLY') {
                toaster.createToast({
                    name: 'service-is-readonly',
                    type: 'error',
                    autoHiding: 15000,
                    title: i18n('service-is-readonly-title'),
                });
            }

            // code from sdk
            if (typeof errorData === 'string') {
                parsedError = {
                    status: get(errorResponse, 'status'),
                    code: 'SDK_REQUEST_ERROR',
                    message: 'SDK request error',
                    details: {
                        title: get(errorResponse, 'status'),
                        description: get(errorResponse, 'statusText'),
                    },
                };
            } else {
                parsedError = {
                    status: get(errorData, 'status', 500),
                    code: get(errorData, 'code', 'SDK_REQUEST_ERROR'),
                    message: get(errorData, 'message', 'SDK request error'),
                    details: get(errorData, 'details'),
                    debug: get(errorData, 'debug'),
                };
            }
        } else {
            parsedError = {
                status: 500,
                code: 'SDK_REQUEST_ERROR',
                message: 'SDK request error',
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                details: errorResponse as any,
            };
        }

        throw parsedError;
    },
});

if (window.__DATA__.collabOrgId) {
    sdk.setDefaultHeader({
        name: Header.xCollabOrgId,
        value: window.__DATA__.collabOrgId,
    });
}
// Передаем и collabOrgId и orgId
// это надо для wfaas, потому что он ходит в трекер, которые умеет только в orgIds
if (window.__DATA__.orgId) {
    sdk.setDefaultHeader({
        // gateway проксирует в бэкенд
        name: 'x-org-id',
        value: window.__DATA__.orgId,
    });
}

export {sdk};
